<template>
    <div>
        <div style="width: 100%;text-align: center;margin-bottom: 30px">URL:
            <a target="_blank" :href="url">{{ url }}</a>
        </div>

        <div class="form-box">
            <el-form ref="form" inline :model="queryForm" label-width="80px" style="text-align: center">
                <el-form-item>
                    <el-input v-model="queryForm.userName" placeholder="Name"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-input v-model="queryForm.unitNo" placeholder="Unit"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-input v-model="queryForm.mobileNo" placeholder="Mobile No."></el-input>
                </el-form-item>

                <el-form-item>
                    <el-date-picker
                            clearable
                            v-model="queryForm.created"
                            format="dd MMM yyyy"
                            type="date"
                            placeholder="Submission Date"
                            value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>

                <el-form-item>
                    <el-date-picker
                            clearable
                            format="dd MMM yyyy"
                            placeholder="Approval Date"
                            type="date"
                            v-model="queryForm.approved"
                            value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-form-item>
                        <el-select v-model="queryForm.status" placeholder="Approval Status" clearable>
                            <el-option
                                    v-for="item in [{lab:'Pending',val:1},{lab:'Approved',val:2},{lab:'Partly Approved',val:3},{lab:'Rejected',val:4}]"
                                    :key="'h-s-'+item.val"
                                    :label="item.lab"
                                    :value="item.val">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form-item>

                <el-button type="primary" @click="loadData" icon="el-icon-search" size="medium" circle></el-button>
                <!--                <el-button type="primary" @click="exportData" icon="el-icon-download" size="medium" circle></el-button>-->
            </el-form>
        </div>

        <el-table
                v-loading="loading"
                fit
                stripe
                class="data-table"
                :data="data">
            <el-table-column
                    header-align="center"
                    align="center"
                    label="Action"
                    width="100px">
                <template slot-scope="s">
                    <el-button size="small" type="primary" v-if="s.row.status===1" @click="openAuditForm(s.row.id)">
                        Approve
                    </el-button>

                    <el-button size="small" type="primary"
                               @click="preview(s.row)">View
                    </el-button>
                </template>
            </el-table-column>

            <el-table-column
                    header-align="center"
                    align="center"
                    v-for="(item, index) in tableTitles"
                    v-if="index < 7"
                    width="209px"
                    :formatter="item.fmt"
                    :prop="item.prop"
                    :label="item.label"
                    :key="item.label">
            </el-table-column>
        </el-table>

        <div class="page">
            <el-pagination @current-change="loadData"
                           :page-size="page.size"
                           :current-page.sync="page.page"
                           :page-count="page.totalPage"
                           layout="prev, pager, next"
                           :total="data.total">
            </el-pagination>
        </div>

        <el-dialog
                center
                v-if="dialogVisible"
                :visible.sync="dialogVisible"
                fullscreen>

            <el-form ref="form" id="form" :model="form" label-width="90px" label-position="top">
                <div v-for="(p,pIdx) in form" :key="p.partName">
                    <el-divider content-position="left">{{ p.partName }}</el-divider>
                    <register-item :disabled="disabled" :items="p.items" v-if="pIdx===0"
                                   :key="pIdx-'m'"></register-item>
                    <div v-else>
                        <div class="file-button" v-if="p.filePath">
                            <el-button @click="openWindows(p.filePath,true)" type="warning" plain><strong>Tenancy
                                Agreement</strong></el-button>
                        </div>
                        <el-card v-for="(subItem,sIdx) in p.items" :key="pIdx-'m'+sIdx" style="margin-bottom: 20px">
                            <register-item :disabled="disabled" :items="subItem"></register-item>
                        </el-card>
                    </div>
                </div>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button type="primary" v-if="status==='1'" @click="openAuditForm">Review</el-button>
                <el-button type="primary" icon="el-icon-print" @click="printForm">Print</el-button>
            </div>
        </el-dialog>

        <el-dialog
                append-to-body
                center fullscreen
                v-if="auditDialog"
                :visible.sync="auditDialog">
            <el-form ref="form" :model="auditForm">
                <el-form-item prop="status" style="text-align: center">
                    <el-select v-model="auditForm.status">
                        <el-option
                                v-for="item in [
                                 {lab:'Approve',val:2},{lab:'Partly Approve',val:3},{lab:'Reject',val:4}
                                ]"
                                :key="item.val+'aa-a-f'"
                                :label="item.lab"
                                :value="item.val">
                        </el-option>
                    </el-select>
                </el-form-item>

                <div v-if="auditForm.status ===3">
                    <el-divider/>

                    <el-form-item style="margin-left: 200px">
                        <audit-item v-for="(item,i) in auditForm.data[1].items" :key="i+'aa'"
                                    :items="item"></audit-item>
                    </el-form-item>
                </div>

                <el-form-item v-if=" auditForm.status ===3 || auditForm.status ===4" label="Reason"
                              :required="auditForm.status ===3"
                              prop="status" style="margin-left: 200px">
                    <el-input v-model="auditForm.reason" type="textarea" :autosize="{ minRows: 2 }" style="width: 80%;"
                              placeholder="Enter reason for rejection"></el-input>
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button @click="auditDialog = false">Cancel</el-button>
                <el-button :disabled="btnDisabled" type="primary" @click="audit">Submit</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {registerRecords, registerTpl, updateRegisterRecords} from '@/api/PropertyApi'
import store from '@/store/index'
import print from 'print-js'
import RegisterItem from "@/view/property/register/RegisterItem";
import AuditItem from "@/view/property/register/AuditItem";
import {openWindows} from "@/utils/WindowsUtils";

export default {
    name: "RegisterRequests",
    components: {AuditItem, RegisterItem},
    data: function () {
        return {
            url: '',
            id: 0,
            status: 0,
            tableTitles: [],
            queryForm: {},
            auditForm: {},
            disabled: true,
            btnDisabled: false,
            auditDialog: false,
            dialogVisible: false,
            form: {},
            loading: false,
            data: [],
            page: {'page': 1, 'size': 10, 'totalPage': 1, 'total': 0}
        }
    },
    methods: {
        openWindows: openWindows,
        printForm() {
            print({
                printable: 'form',
                type: 'html',
                css: 'https://unpkg.com/element-ui@2.13.0/lib/theme-chalk/index.css',
            })
        },
        audit() {
            this.btnDisabled = true
            const data = this.$copy(this.auditForm)
            data.data = JSON.stringify(data.data)
            updateRegisterRecords(this.auditForm)
                .then(() => {
                    this.loadData()
                    this.auditDialog = false
                    this.dialogVisible = false
                }).catch(() => this.btnDisabled = false)
        },
        openAuditForm() {
            this.btnDisabled = false
            this.auditDialog = true
        },
        preview(data) {
            this.id = data.id
            this.status = data.status
            this.form = this.$copy(data.data)
            this.auditForm = {
                id: this.id,
                status: 2,
                data: this.form
            }
            this.dialogVisible = true
        },
        loadData() {
            this.$pageUtils(this, registerRecords, this.dataConvert)
        },
        dataConvert(data) {
            return data.map(item => {
                item.data = JSON.parse(item.data)
                if (item.data.length > 0) {
                    item.data[0]["items"].forEach(it => {
                        item[it["name"].replace(/\s+/g, "")] = it["data"]
                    });
                }
                return item
            })
        }
    },
    mounted() {
        registerTpl()
            .then(res => {
                this.url = 'https://registration.eazable.asia/#/?id=' + store.state.userInfo.propertyId
                this.tableTitles = JSON.parse(res.data)
                    .map(item => item["items"])
                    .flat()
                    .map(item => {
                        return {"prop": item["name"].replace(/\s+/g, ""), "label": item["name"]}
                    })
                this.tableTitles.unshift({"prop": "created", label: "Created", fmt: this.selfTimeFormat})
                this.tableTitles.unshift({"prop": "reason", label: "Reason for Rejection"})
                this.tableTitles.unshift({
                    "prop": "status",
                    "label": "Status",
                    fmt: (row, cell, val) => {
                        return {
                            1: "Pending",
                            2: "Approved",
                            3: "Partly Approved",
                            4: "Rejected",
                        }[val]
                    }
                })
            })
        this.loadData()
    }
}
</script>

<style scoped>
/deep/ .el-input.is-disabled .el-input__inner {
    background-color: unset;
    border-color: unset;
    color: unset;
}

/deep/ .el-range-editor.is-disabled input {
    background-color: unset;
    color: unset;
}

/deep/ .el-range-editor.is-disabled {
    background-color: unset;
    color: unset;
}

/deep/ .el-radio__input.is-checked + .el-radio__label {
    color: #409EFF;
}

.file-button {
    padding-bottom: 15px;
    text-align: right;
    width: 100%;
}
</style>
